// for product description to show less & more content
  document.addEventListener("DOMContentLoaded", function () {
    const toggles = document.querySelectorAll(".read_more_toggle");

    toggles.forEach(function(toggle) {
      toggle.addEventListener("click", function () {
        const container = toggle.closest(".product-description-full");
        const partial = container.querySelector(".desc-partial");
        const full = container.querySelector(".desc-full");

        if (partial.style.display === "none") {
          partial.style.display = "block";
          full.style.display = "none";
        } else {
          partial.style.display = "none";
          full.style.display = "block";
        }
      });
    });
  });

// to wrap the qty and buy now btn in PDP
$('.product-form__quantity, .cstm-buy-btn-block').wrapAll('<div class="pdp-qty-with-buy"></div>');



